import React from 'react'
import {useNavigate} from 'react-router-dom'
import './GetStartedSplashScreen.scss'
import GetStartedSplashScreen from './GetStartedSplashScreen'
import FeatureSplashPage from '../../../Components/FeatureSplashPage'

const GetStartedPage: React.FC = () => {
  const embedVideoUrl = 'https://www.loom.com/embed/412421fea68b4ccd94f0744b51d24b62'
  const navigate = useNavigate()

  const handleNext = () => {
    navigate('/card-templates')
  }

  return (
      <div className='get-started-page'>
        <FeatureSplashPage
        title='Get Started'
        descText='Overview'
        description={<GetStartedSplashScreen />}
        onActivate={handleNext}
        ctaLabel='Next'
        showEmbedVideo={true}
        embedVideoUrl={embedVideoUrl}
      />
      </div>
  )
}

export default GetStartedPage

